import { render } from "./CorrespondenceView.vue?vue&type=template&id=65ec5154&scoped=true"
import script from "./CorrespondenceView.vue?vue&type=script&lang=js"
export * from "./CorrespondenceView.vue?vue&type=script&lang=js"

import "./CorrespondenceView.vue?vue&type=style&index=0&id=65ec5154&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ec5154"]])

export default __exports__